import { DelegatorResult, PaginatedResponse } from '@block-explorer/entities';
import { createAsyncAction } from 'typesafe-actions';
import { PaginationParams } from '../../services';

export const getAccountDelegationsAsync = createAsyncAction(
  'GET_ACCOUNT_DELEGATIONS_REQUEST',
  'GET_ACCOUNT_DELEGATIONS_SUCCESS',
  'GET_ACCOUNT_DELEGATIONS_FAILURE'
)<
  Partial<PaginationParams & { publicKey: string }>,
  PaginatedResponse<DelegatorResult>,
  string
>();
